class Search {
	constructor() {
		( function ( $ ) {
            "use strict";

			let searchTimeout;
			const searchComponent = $('#gaia_search');
			window.gaiaSearching = false;

			searchComponent.on('input blur change', 'input', function() {
				var searchQuery = $(this).val();
				if (!window.gaiaSearching && searchQuery.length < 3) {
					// HSComboBox.getInstance('#gaia_search', true).element.close();
					
					$('.gaia_search_results_container').hide();
					$('.gaia_searching').hide();
					searchComponent.removeClass('loading');
					$('.gaia_search_results').empty();

					setTimeout(() => {
						$('.gaia_search_results_container').hide();
						$('.gaia_searching').hide();
					}, 200);
				}
			});
				
			searchComponent.on('keyup', 'input', function() {
				clearTimeout(searchTimeout);

				var searchQuery = $(this).val();
		
				if (searchQuery.length > 2) {
					// Inicia o temporizador de 500ms
					searchTimeout = setTimeout(function() {
						$.ajax({
							url: gaiaCustomData.ajax_url,
							type: 'GET',
							data: {
								action: 'gaia_search_products',
								search_term: searchQuery
							},
							beforeSend: function(){
								window.gaiaSearching = false;
								searchComponent.addClass('loading');
							},
							success: function(response) {
								if (response.success) {
									var products = response.data;
									var resultHtml = '';
			
									$.each(products, function(index, product) {
										resultHtml += '<div data-hs-combo-box-output-item="{"group": {"name": "produto", "title": "Produto"}}" tabindex="7">';
											resultHtml += '<a class="py-2 px-2.5 flex items-center justify-between gap-x-3 hover:bg-gray-100 rounded-lg focus:outline-none focus:bg-gray-100 dark:hover:bg-neutral-700 dark:focus:bg-neutral-700" href="' + product.url + '">';
												resultHtml += '<div class="flex items-center gap-x-3">';
													resultHtml += '<img class="shrink-0 size-5 rounded-full" src="' + product.image + '" alt="' + product.title + '">';
													resultHtml += '<span class="text-sm text-gray-800 dark:text-neutral-200 leading-tight" data-hs-combo-box-search-text="' + product.title + '" data-hs-combo-box-value="">' + product.title + '</span>';
												resultHtml += '</div>';
												resultHtml += '<span class="ms-auto text-xs text-gray-400 dark:text-neutral-500 text-right" data-hs-combo-box-search-text="' + product.title + '" data-hs-combo-box-value="">' + product.price + '</span>';
											resultHtml += '</a>';
										resultHtml += '</div>';
									});
			
									setTimeout(() => {
										window.gaiaSearching = false;
										$('.gaia_search_results_container').show();
										searchComponent.removeClass('loading');
										$('.gaia_search_results').html(resultHtml);
									}, 1500);
								} else {
									setTimeout(() => {
										window.gaiaSearching = true;
										$('.gaia_search_results_container').show();
										searchComponent.removeClass('loading');
										$('.gaia_search_results').html('<div class="py-2 px-2.5">' + response.data + '</div>');
									}, 1500);
								}
							}
						});
					}, 500);
				}
			});

			// searchComponent.on('keypress', 'input', function(e) {
			// 	e.preventDefault();
			// 	const key = e.which;
			// 	if(key == 13) {
			// 		console.log($(this).find('input').val());
			// 		var searchValue = $(this).find('input').val();
			// 		window.location = '/search/?sq=' + searchValue;
			// 	}
			// });

			searchComponent.on('keypress keydown keyup', 'input', function(e) {
				if(e.key === 'Enter') { 
					e.preventDefault(); 
					// console.log(e);
					var searchValue = $(this).val();
					if (searchValue != '') window.location = t('search.url_search') + '?sq=' + searchValue;
					return false;
				}
			});
			
			$('#open-gaia-search').on('click', function(){
				HSOverlay.getInstance('#gaia-mobile-search-box', true).element.open();
			});

			const searchMobileComponent = $('#gaia-mobile-search-box-combobox');

			searchMobileComponent.on('keyup', 'input', function() {
				clearTimeout(searchTimeout);

				var searchQuery = $(this).val();
		
				if (searchQuery.length > 2) {
					// Inicia o temporizador de 500ms
					searchTimeout = setTimeout(function() {
						$.ajax({
							url: gaiaCustomData.ajax_url,
							type: 'GET',
							data: {
								action: 'gaia_search_products',
								search_term: searchQuery
							},
							beforeSend: function(){
								window.gaiaSearching = false;
								searchMobileComponent.find('.gaia-mobile-search-box-field').addClass('loading');
							},
							success: function(response) {
								if (response.success) {
									var products = response.data;
									var resultHtml = '';
			
									$.each(products, function(index, product) {
										resultHtml += '<div data-hs-combo-box-output-item="{"group": {"name": "produto", "title": "Produto"}}" tabindex="7">';
											resultHtml += '<a class="py-2 px-2.5 flex items-center justify-between gap-x-3 hover:bg-gray-100 rounded-lg focus:outline-none focus:bg-gray-100 dark:hover:bg-neutral-700 dark:focus:bg-neutral-700" href="' + product.url + '">';
												resultHtml += '<div class="flex items-center gap-x-3">';
													resultHtml += '<img class="shrink-0 size-5 rounded-full" src="' + product.image + '" alt="' + product.title + '">';
													resultHtml += '<span class="text-sm text-gray-800 dark:text-neutral-200 leading-tight" data-hs-combo-box-search-text="' + product.title + '" data-hs-combo-box-value="">' + product.title + '</span>';
												resultHtml += '</div>';
												resultHtml += '<span class="ms-auto text-xs text-gray-400 dark:text-neutral-500 text-right" data-hs-combo-box-search-text="' + product.title + '" data-hs-combo-box-value="">' + product.price + '</span>';
											resultHtml += '</a>';
										resultHtml += '</div>';
									});
			
									setTimeout(() => {
										window.gaiaSearching = false;
										searchMobileComponent.find('.gaia-mobile-search-box-field').removeClass('loading');
										searchMobileComponent.find('[data-hs-combo-box-output-items-wrapper]').html(resultHtml);
									}, 1500);
								} else {
									setTimeout(() => {
										window.gaiaSearching = true;
										searchMobileComponent.find('.gaia-mobile-search-box-field').removeClass('loading');
										searchMobileComponent.find('[data-hs-combo-box-output-items-wrapper]').html('<div class="py-2 px-2.5">' + response.data + '</div>');
										// $('.gaia_search_results').html('<div class="py-2 px-2.5">' + response.data + '</div>');
									}, 1500);
								}
							}
						});
					}, 500);
				}
			});

			searchMobileComponent.keypress(function (e) {
				const key = e.which;
				if(key == 13) {
					var searchValue = $(this).find('input').val();
					window.location = t('search.url_search') + '?sq=' + searchValue;
				}
			});

			let searchPageTimeout;
			const searchPageComponent = $('#gaia_search_field');
			if (searchPageComponent.length) {
				function getUrlParameter(name) {
					let regex = new RegExp('[?&]' + name + '=([^&#]*)');
					let results = regex.exec(window.location.search);
					return results === null ? null : decodeURIComponent(results[1]);
				}

				window.currentQuery = getUrlParameter('sq');
				function searchingTerm(order) {
					var searchQuery = searchPageComponent.find('input').val();

					if (window.currentQuery == searchQuery && !order) return; 

					let orderby = getUrlParameter('orderby') ? getUrlParameter('orderby') : 'price';
					if (order) orderby = order; 
					let orderby_param = orderby ? '&orderby=' + orderby : '';

					// Constrói a query string para a URL
					let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?sq=' + searchQuery + orderby_param;
	
					// Atualiza a URL sem recarregar a página
					history.pushState(null, null, newUrl);
					
					$.ajax({
						url: gaiaCustomData.ajax_url,
						type: 'GET',
						data: {
							action: 'gaia_search_products',
							search_term: searchQuery,
							search_page: true,
							orderby: orderby
						},
						beforeSend: function(){
							window.gaiaSearching = false;
							window.currentQuery = searchQuery;
							searchPageComponent.addClass('loading');
							$('.gaia_search_content').find('.product_item_grid').addClass('loading');
						},
						success: function(response) {
							if (response.success) {
								var products = response.data.html;
		
								setTimeout(() => {
									window.gaiaSearching = false;
									searchPageComponent.removeClass('loading');
									$('.gaia_search_content').html(products);
									$('.gaia_search_pagination').data('currentpage', response.data.current_page);
									$('.gaia_search_pagination').data('maxpages', response.data.max_pages);

									if (response.data.max_pages <= 1) {
										$('.gaia_search_pagination').hide();
									} else {
										$('.gaia_search_pagination').show();
									}
								}, 1500);
							} else {
								setTimeout(() => {
									window.gaiaSearching = true;
									searchPageComponent.removeClass('loading');
									$('.gaia_search_content').html('<div class="py-2 px-2.5">' + response.data + '</div>');
								}, 1500);
							}
						}
					});
				}

				searchPageComponent.on('keyup', 'input', function() {
					clearTimeout(searchPageTimeout);
					var searchValue = $(this).val();
					if (searchValue.length > 2) {
						searchPageTimeout = setTimeout(function() {
							searchingTerm();
						}, 1000);
					}
				});

				searchPageComponent.keypress(function (e) {
					const key = e.which;
					if(key == 13) {
						searchingTerm();
					}
				});

				// AJAX paginação de produtos da categoria
				$('.gaia_load_more_search').on('click', function() {
					let button = $(this);
					let container = $('.gaia_search_pagination');
					let currentPage = container.data('currentpage');
					let maxPages = container.data('maxpages');
					let searchTerm = searchPageComponent.find('input').val();
					let orderby = getUrlParameter('orderby') ? getUrlParameter('orderby') : 'price';
					let orderby_param = orderby ? '&orderby=' + orderby : '';
			
					// Atualiza o número da página
					let nextPage = parseInt(currentPage) + 1;
	
					// Constrói a query string para a URL
					let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?sq=' + searchTerm + '&pg=' + nextPage + orderby_param;
	
					// Atualiza a URL sem recarregar a página
					history.pushState(null, null, newUrl);
			
					// Desativa o botão enquanto a requisição está em andamento
					button.addClass('loading');
					
					// Faz a requisição AJAX
					$.ajax({
						url: gaiaCustomData.ajax_url,
						type: 'POST',
						data: {
							action: 'gaia_load_more_search',
							search_term: searchTerm,
							page: nextPage,
							orderby: orderby
						},
						success: function(response) {
							if (response.success) {
								// Adiciona os novos produtos ao container
								var newItems = $(response.data.html).hide();
								$('.gaia_search_content').append(newItems);
								newItems.fadeIn('slow');
								
								// Atualiza o número da página atual
								container.data('currentpage', nextPage);
	
								// Rolagem suave até os novos produtos inseridos
								$('html, body').animate({
									scrollTop: newItems.first().offset().top
								}, 'slow');
			
								// Oculta o botão de "Veja mais" se chegou ao máximo de páginas
								if (nextPage >= maxPages) {
									button.parent().hide();
								}
							} else {
								// console.log('Erro ao carregar mais produtos.');
							}
						},
						error: function(error) {
							// console.log(error);
						},
						complete: function() {
							// Remove a classe de loading e restaura o botão
							button.removeClass('loading');
						}
					});
				});

				// Mudar ordem dos resultados da busca
				$('select[name="gaia_search_orderby"]').on('change', function(e) {
					e.preventDefault();
					const order = $(this).val();
					searchingTerm(order);
				});

				// Scroll até a página
				let page = getUrlParameter('pg');

				if (page && page > 1) {
					// Obter o número de produtos por página (ajuste conforme necessário)
					let postsPerPage = 8;
			
					// Calcular o índice do primeiro item da página atual
					let firstItemIndex = (page - 1) * postsPerPage;
			
					// Obter todos os produtos na página
					let $products = $('.gaia_search_content .product_item_grid');
			
					// Verificar se o primeiro item existe
					if ($products.eq(firstItemIndex).length) {
						// Fazer o scroll suave até o primeiro item da página atual
						$('html, body').animate({
							scrollTop: $products.eq(firstItemIndex).offset().top
						}, 800);  // 800ms é a duração da animação, ajuste conforme necessário
					}
				}
			}
		}( jQuery ) );
	}
}

export default Search